import axios from "axios";
import MyUserService from "./myUser";
import { AdminResponse, LoginRequest } from "../interface/auth/IAuthResponse";

const { REACT_APP_ENDPOINT } = process.env;
const ENDPOINT = `${REACT_APP_ENDPOINT}/api/auth/`;

export default class AuthService {
  static async login(user: any): Promise<any> {
    const { data } = await axios.post<any>(`${ENDPOINT}login`, user);

    localStorage.setItem("LocalSession", JSON.stringify(data));
    localStorage.setItem(
      "expirationtime",
      JSON.stringify(data.shoopExpirationTime),
    );

    MyUserService.setMostrarPolitica(data.mostrarPoliticasReclamo);
    MyUserService.setShowNps(data.showNps);

    return data;
  }

  static async loginAdmin(user: LoginRequest): Promise<AdminResponse> {
    const { data } = await axios.post<AdminResponse>(
      `${ENDPOINT}loginAdmin`,
      user,
    );

    localStorage.setItem("LocalSession", JSON.stringify(data));

    return data;
  }

  static async resetPassword(request: any): Promise<any> {
    const { data } = await axios.post(`${ENDPOINT}forgotpassword`, request);

    return data;
  }

  static async changePasswordEmail(request: any): Promise<any> {
    const { data } = await axios.post(`${ENDPOINT}resetpassword`, request);

    return data;
  }

  static async changePassword(request: any): Promise<any> {
    const { data } = await axios.post(`${ENDPOINT}changepassword`, request);

    return data;
  }
}
